export default __webpack_public_path__ + "static/media/AER-logo.8770a339.png";